module.exports = __webpack_public_path__ + "img/italy.ee1a29e.webp";